/**
 * Convert percentage to normalized decimal (0-100% -> 0-1)
 * Example: 85% -> 0.85, 5% -> 0.05
 */
export function percentageToDecimal(percentage: number): number {
  return percentage / 100;
}
